namespace $.$$ {
	/** A sized shadow host: display:contents cannot resolve a child's height:100%. */
	export class $shm_hitalama_map_widget_view_dom extends $.$shm_hitalama_map_widget_view_dom {
		@ $mol_mem
		override render() {
			super.render()
			const host = this.dom_node_actual()
			const shadow = host.shadowRoot ?? host.attachShadow({mode:'open'})
			this.$.$mol_dom_render_children(shadow,[this.content()])
		}
	}
}
